export const getSectionsGridRows = (crewExpanded: boolean, equipmentExpanded: boolean) => {
  if (crewExpanded && equipmentExpanded) return 'grid-rows-[minmax(0,1fr)_fit-content(50%)]';
  if (crewExpanded) return 'grid-rows-[minmax(0,1fr)_auto]';
  if (equipmentExpanded) return 'grid-rows-[auto_minmax(0,auto)]';
  return 'grid-rows-[auto_auto]';
};
